import { factory } from "../../../../utils/apiThunkFactory";

export const getAllRolesAndUsers = factory.get("userManagement/getAllRolesAndUsers", "/api/roles/users/all");

export const getAllRolesAndPermissions = factory.get("userManagement/getAllRolesAndPermissions", "/api/roles/permissions/all");

export const getAllUsers = factory.get("userManagement/getAllUsers", "/api/users/list");

export const getAllUserPerRoleId = factory.get("userManagement/getAllUserPerRoleId", "/api/roles/id/:role_id");

export const createRole = factory.post("userManagement/createRole", "/api/roles/create");

export const deleteRole = factory.delete("userManagement/deleteRole", "/api/roles/delete/:role_id");

export const removeRoleFromUserId = factory.delete("userManagement/removeRoleFromUserId", "/api/users/id/:user_id/roles/:role_id");

export const addRoleToUserId = factory.post("userManagement/addRoleToUserId", "/api/users/id/:user_id/roles/:role_id");

export const getAllPermissions = factory.get("kanban/getAllPermissions", "/api/permissions");

export const getRolePermissions = factory.get("kanban/getRolePermissions", "/api/roles/id/:role_id/permission");

export const getPermissionInfoRole = factory.get("kanban/getPermissionInfoRole", "/api/permissions/id/:permission_id/role/:role_id");

export const removeRolePermission = factory.delete("kanban/removeRolePermission", "/api/roles/id/:role_id/permission/:permission_id");

export const addRolePermission = factory.post("kanban/addRolePermission", "/api/roles/id/:role_id/permission/:permission_id");

export const getAllRolesByTenant = factory.get("kanban/getAllRolesByTenant", "/api/tenants/roles/:tenant_id");

export const getPermissionInfoRoom = factory.get("kanban/getPermissionInfoRoom", "/api/permissions/id/:permission_id/room/:room_id");


export const removeRoomPermission = factory.delete("kanban/removeRoomPermission", "/api/rooms/id/:room_id/permission/:permission_id");

export const addRoomPermission = factory.post("kanban/addRoomPermission", "/api/rooms/id/:room_id/permission/:permission_id");

export const getRooms = factory.get("kanban/getRooms", "/api/rooms/list/:tenant_id");

